module.exports = {"421122100":"城关镇","421122101":"七里坪镇","421122102":"华河镇","421122103":"二程镇","421122104":"上新集镇","421122105":"高桥镇","421122106":"觅儿镇","421122107":"八里镇","421122108":"太平桥镇","421122109":"永河镇","421122200":"杏花乡","421122500":"火连畈茶场","421122501":"天台山旅游开发管理处","421122503":"红安经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421122.json
// module id = 1623
// module chunks = 0